import React from 'react';
import { Page } from '../../ui';
import { TAC } from '../webshop/components/CopyForTaC';
import { CONTENT_SMALL } from '../../utils/media';
import { useUser } from '../auth/hooks';
import PageSection from '../../ui/Page/PageSection';

const CoursioTermsAndConditions = () => {
  const user = useUser();
  const language = user?.locale || 'en_US';
  const pageContent = TAC[language] || TAC['en_US'];

  return (
    <Page>
      <PageSection align={'left'} size={CONTENT_SMALL}>
        {pageContent}
      </PageSection>
    </Page>
  )
}

export default CoursioTermsAndConditions;

